// khasApi.js — API helper untuk Zona KHAS

const BASE_URL = process.env.REACT_APP_KHAS_API_URL || '/api/khas'

// ── Helper fetch ──────────────────────────────────────────
async function apiFetch(endpoint, { method = 'GET', body, auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json' }

  if (auth) {
    const token = localStorage.getItem('khas_token')
    if (token) headers['Authorization'] = `Bearer ${token}`
  }

  const res = await fetch(`${BASE_URL}${endpoint}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  })

  const data = await res.json()

  if (!res.ok) {
    throw new Error(data.error || 'Terjadi kesalahan')
  }

  return data
}

// ── Upload helper (untuk form-data) ──────────────────────
async function apiUpload(endpoint, formData) {
  const token = localStorage.getItem('khas_token')
  const headers = {}
  if (token) headers['Authorization'] = `Bearer ${token}`

  const res = await fetch(`${BASE_URL}${endpoint}`, {
    method: 'POST',
    headers,
    body: formData,
  })

  const data = await res.json()
  if (!res.ok) throw new Error(data.error || 'Terjadi kesalahan')
  return data
}

// ── Auth ──────────────────────────────────────────────────
export const authApi = {
  login: (body) => apiFetch('/auth/login', { method: 'POST', body, auth: false }),
  gantiPassword: (body) => apiFetch('/auth/ganti-password', { method: 'PUT', body }),
  me: () => apiFetch('/auth/me'),
}

// ── Users ─────────────────────────────────────────────────
export const usersApi = {
  getAll: () => apiFetch('/users'),
  create: (body) => apiFetch('/users', { method: 'POST', body }),
  update: (id, body) => apiFetch(`/users/${id}`, { method: 'PUT', body }),
  resetPassword: (id, body) => apiFetch(`/users/${id}/reset-password`, { method: 'PUT', body }),
  delete: (id) => apiFetch(`/users/${id}`, { method: 'DELETE' }),
}

// ── Pengajuan ─────────────────────────────────────────────
export const pengajuanApi = {
  getAll: () => apiFetch('/pengajuan'),
  getById: (id) => apiFetch(`/pengajuan/${id}`),
  create: (formData) => apiUpload('/pengajuan', formData),
  update: (id, body) => apiFetch(`/pengajuan/${id}`, { method: 'PUT', body }),
  updateStatus: (id, body) => apiFetch(`/pengajuan/${id}/status`, { method: 'PUT', body }),
  delete: (id) => apiFetch(`/pengajuan/${id}`, { method: 'DELETE' }),
}

// ── Penetapan ─────────────────────────────────────────────
export const penetapanApi = {
  getAll: () => apiFetch('/penetapan'),
  getPublik: () => apiFetch('/penetapan/publik'),
  getById: (id) => apiFetch(`/penetapan/${id}`),
  create: (formData) => apiUpload('/penetapan', formData),
  update: (id, body) => apiFetch(`/penetapan/${id}`, { method: 'PUT', body }),
  updateStatus: (id, body) => apiFetch(`/penetapan/${id}/status`, { method: 'PUT', body }),
  kirimSurat: (id, formData) => apiUpload(`/penetapan/${id}/kirim-surat`, formData),
}